export default __webpack_public_path__ + "static/media/Apple_Music_Icon_wht_lg_072420.ce798ae6.svg";